"use strict";
/**
 * 获取当前 EH 版本号
 *
 * ### Example
 * ```
 * const version = getEHVersion();
 * ```
 */
Object.defineProperty(exports, "__esModule", { value: true });
function getEHVersion() {
    var ua = navigator.userAgent.toLowerCase();
    var match = ua.match(/eh\/([0-9\.]*)/);
    return match ? match[1] : '';
}
exports.getEHVersion = getEHVersion;
